/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Not_EnabledInputs */

const en_issue_not_enabled = /** @type {(inputs: Issue_Not_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not enabled`)
};

/**
* | output |
* | --- |
* | "not enabled" |
*
* @param {Issue_Not_EnabledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_not_enabled = /** @type {((inputs?: Issue_Not_EnabledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Not_EnabledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_not_enabled(inputs)
});